import { FunctionComponent, useState, useEffect } from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useLocation, useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import IntegrationCard from '../../components/Cards/IntegrationCard'
import axios from '../../../src/utils/axios'

const Settings: FunctionComponent = () => {
  const styles = useStyles()
  const location = useLocation()
  const navigate = useNavigate()
  const [fetching, setFetching] = useState(true)
  const [integrations, setIntegrations] = useState<{ mailchimp?: boolean, stripe?: boolean }>({})

  // Stripe Connect can be registered to come back to /settings, which is the
  // shorter URL but not the page that exchanges the code. Forward rather than
  // exchange here, so there is still exactly one place that does it - two
  // would eventually disagree.
  //
  // Safe to key off `code` alone: this component renders only at /settings
  // exactly, so Mailchimp's callback (a sibling route) never reaches it.
  useEffect(() => {
    const { code } = queryString.parse(location.search)
    if (!code) return

    navigate(`/settings/integrations/stripe/connect?code=${code}`, { replace: true })
  }, [location, navigate])

  useEffect(() => {
    (async () => {
      setFetching(true)
      const res = await axios.get('/organization/settings')
      setIntegrations(res.data)
      setFetching(false)
    })()
  }, [])
  return (
    <Box p={2}>
      <Box mb={2}>
        <Typography variant={'h3'}>
          Integrations
        </Typography>
        <Typography variant={'caption'}>
          Integrate Stitch with 3rd-party applications to get user data where it needs to be.
        </Typography>
      </Box>
      <Box className={styles.cardContainer}>
        <Box mr={2}>
          <IntegrationCard
            connected={!!integrations.mailchimp}
            loading={fetching}
            title="MailChimp"
            bodyText="Automatically sync your patrons to your MailChimp account so you can put them in automated email workflows and segmented lists."
            backgroundImagePath={'mailchimp.png'}
            connectHandler={() => window.location.replace(`https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=${process.env.REACT_APP_MAILCHIMP_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_MAILCHIMP_REDIRECT_URI}`)}
            editPath="/settings/integrations/mailchimp"
          />
        </Box>
        <Box>
          <IntegrationCard
            connected={!!integrations.stripe}
            loading={fetching}
            title="Stripe"
            bodyText="Connect your stripe account to receive membership payouts to your account."
            backgroundImagePath={'connect_stripe.png'}
            connectHandler={() => window.location.replace(`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${process.env.REACT_APP_STRIPE_REDIRECT_URI}`)}
          />
        </Box>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles({
  container: {
    borderRadius: 5,
    border: '2px solid red'
  },
  cardContainer: {
    display: 'flex'
  }
})

export default Settings
